import styled from '@emotion/styled';

export const Wrapper = styled.div`
  position: fixed;
  width: 100vw;
  height: 100vh;
  z-index: 20000;
  left: 0;
  top: 0;
  transition: ${props => props.theme.transitions.default};
  visibility: ${props => (props.isActive ? 'display' : 'hidden')};
  opacity: ${props => (props.isActive ? 1 : 0)};
  display: flex;
  align-items: center;
  justify-content: center;
`;

export const Overlay = styled.div`
  width: 100%;
  height: 100%;
  background-color: ${props => props.theme.colors.black};
  opacity: 0.5;
`;
